import React from 'react';
import PropTypes from 'prop-types';
import { FAQsParagraph, FAQsWrapper } from './FAQs.styled';
import { SubPageTitle } from '../../pages/AnalysisPage/AnalysisPage.styled';

const FAQs = () => (
 <FAQsWrapper>
    <FAQsParagraph>
      <div>
      The estimates presented in this tool rely on user inputs, cost data from publicly funded L2 chargers in 
      certain states, and assumptions about driving and charging behaviors that can be adjusted in the advanced configurations.
      </div>
      <SubPageTitle>Cost Estimates</SubPageTitle>
      <div>
      The cost of installing EV chargers in multi-family properties during the property development phase of a new construction 
      is typically significantly cheaper than adding charging afterwards. Large costs, such as those associated with electrical 
      panel upgrades, are shared across the entire building costs, rather than just for charging. Charger installation costs are 
      typically lower as well since there is less or no rework.
      </div>
      <div>
      Cost estimates are based on:
      <li>Costs from over 700 charging equipment installation projects</li>
      <li>Binned project costs that account for cost differences between low and high port count projects</li>
      <li>Labor costs that are scaled up and down based on the project state's average electrician wage</li>
      <li>An assumption of one charging port per parking space to be electrified</li>
      </div>
      <SubPageTitle>Incentives</SubPageTitle>
      <div>
      The tool includes over 150 state and utility incentives. By default, the tool selects the 
      two most valuable incentives (up to 90% of the total one-time costs) and applies them when calculating the ROI. 
      The exact amount that a project can obtain from an incentive program can vary and there may be restrictions on receiving 
      multiple sources of funding. The values applied to the ROI should be verified by the user by contacting the incentive provider.
      </div>
      <SubPageTitle>Revenue</SubPageTitle>
      <div>
      Revenue by default is coming from the cost difference of charging at home vs. at public DC fast charger stations. 
      The values of at home charging are average commercial charging rates, inclusive of fees such as demand charges. 
      Any user entered revenue is assumed to go to the building. The advanced inputs default to state level values, 
      such as annual vehicle miles, that are key to the revenue calculation. The tool also assumes that chargers will be 
      utilized to their full capacity immediately after installation.
      </div>
    </FAQsParagraph>
 </FAQsWrapper>
);

FAQs.propTypes = {};

FAQs.defaultProps = {};

export default FAQs;
